import { getSpecialCharactersRegex } from '@pe-libs/react-components/build/lib/helper';
import yup from '#schema/locale';

const PeOnboardingSchemaPage3 = yup.object({
  profileIndustry: yup
    .string()
    .required()
    .trim(),
  profileIndustryCustom: yup
    .string()
    .max(100)
    .when('profileIndustry', {
      is: (value: string) => value === 'profileIndustryCustom',
      then: (schema: yup.StringSchema) =>
        schema
          .required()
          .min(5)
          .matches(getSpecialCharactersRegex())
          .trim(),
    }),
});

export default PeOnboardingSchemaPage3;
